import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AssignSubjects = () => {
  const [assignments, setAssignments] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [filteredSemesters, setFilteredSemesters] = useState([]);
  const [filteredSubjects, setFilteredSubjects] = useState([]);

  const [form, setForm] = useState({
    teacher_id: '',
    program_id: '',
    semester_id: '',
    subject_id: ''
  });

  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchAssignments();

    axios.get('http://localhost:8081/api/admin/teachers').then(res => setTeachers(res.data));
    axios.get('http://localhost:8081/api/admin/programs').then(res => setPrograms(res.data));
    axios.get('http://localhost:8081/api/admin/semesters').then(res => setSemesters(res.data));
    axios.get('http://localhost:8081/api/admin/subjects').then(res => setSubjects(res.data));
  }, []);

  useEffect(() => {
    if (form.program_id) {
      const filtered = semesters.filter(s => s.program_id === parseInt(form.program_id));
      setFilteredSemesters(filtered);
      setFilteredSubjects([]);
      setForm(prev => ({ ...prev, semester_id: '', subject_id: '' }));
    }
  }, [form.program_id, semesters]);

  useEffect(() => {
    if (form.semester_id) {
      const filtered = subjects.filter(s => s.semester_id === parseInt(form.semester_id));
      setFilteredSubjects(filtered);
      setForm(prev => ({ ...prev, subject_id: '' }));
    }
  }, [form.semester_id, subjects]);

  const fetchAssignments = async () => {
    const res = await axios.get('http://localhost:8081/api/admin/teacher-assignments');
    setAssignments(res.data);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (editingId) {
      await axios.put(`http://localhost:8081/api/admin/teacher-assignments/${editingId}`, form);
    } else {
      await axios.post('http://localhost:8081/api/admin/teacher-assignments', form);
    }
    fetchAssignments();
    resetForm();
  };

  const resetForm = () => {
    setForm({ teacher_id: '', program_id: '', semester_id: '', subject_id: '' });
    setEditingId(null);
  };

  const handleEdit = (assignment) => {
    setForm({
      teacher_id: assignment.teacher_id,
      program_id: assignment.program_id,
      semester_id: assignment.semester_id,
      subject_id: assignment.subject_id
    });
    setEditingId(assignment.id);
  };

  const handleDelete = async (id) => {
    await axios.delete(`http://localhost:8081/api/admin/teacher-assignments/${id}`);
    fetchAssignments();
  };

  return (
    <div className="assignment-container">
      <h2>Assign Subjects to Teachers</h2>
      <div className="assignment-form">
        <select name="teacher_id" value={form.teacher_id} onChange={handleChange}>
          <option value="">Select Teacher</option>
          {teachers.map(t => (
            <option key={t.id} value={t.id}>{t.full_name}</option>
          ))}
        </select>

        <select name="program_id" value={form.program_id} onChange={handleChange}>
          <option value="">Select Program</option>
          {programs.map(p => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>

        <select name="semester_id" value={form.semester_id} onChange={handleChange}>
          <option value="">Select Semester</option>
          {filteredSemesters.map(s => (
            <option key={s.semester_id} value={s.semester_id}>{s.name}</option>
          ))}
        </select>

        <select name="subject_id" value={form.subject_id} onChange={handleChange}>
          <option value="">Select Subject</option>
          {filteredSubjects.map(sub => (
            <option key={sub.id} value={sub.id}>{sub.name}</option>
          ))}
        </select>

        <button onClick={handleSubmit}>{editingId ? "Update" : "Assign"}</button>
      </div>

      <table className="assignment-table">
        <thead>
          <tr>
            <th>Teacher</th>
            <th>Program</th>
            <th>Semester</th>
            <th>Subject</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {assignments.map((a) => (
            <tr key={a.id}>
              <td>{a.teacher}</td>
              <td>{a.program}</td>
              <td>{a.semester}</td>
              <td>{a.subject}</td>
              <td>
                <button onClick={() => handleEdit(a)}>Edit</button>
                <button onClick={() => handleDelete(a.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AssignSubjects;
